import { createSlice} from "@reduxjs/toolkit";
import { isPending } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios'
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import Cookies from "js-cookie";  // 👈 import cookie lib

// let backendURL = process.env.REACT_APP_backend_url;
let backendURL = process.env.REACT_APP_backend_url;
//(apiUrl); // Should output: https://api.example.com
//(apiUrl,process.env)
export const PRCThunk=createAsyncThunk('PRCThunk',async(userCredObj,thunkApi)=>{
    try{
      

        if(userCredObj!=null)
            {  
                  const res=await axios.post(`${backendURL}/login_PRC`,userCredObj, {
                    headers: {
                      'Content-Type': 'application/json',
                      
                    }})
                    
                  if(res.data.message==='PRC Login successful!'){
                   
                    return res.data.user
                   
                
                
                  }
                  else{
                    return thunkApi.rejectWithValue(res.data.error)
                  }
                
            }
          
    }
    catch(err){
        return thunkApi.rejectWithValue(err)
    }
})
export const PRCcheckAuthThunk = createAsyncThunk("PRCCheckAuthThunk", async (_, thunkApi) => {
   
    console.log("why calling me....")
    
    try {
        const res = await axios.get(`${backendURL}/check-auth`,{ withCredentials: true });
        
        return res.data.user;
    } catch (err) {
        return thunkApi.rejectWithValue("Not authenticated");
    }
});

// Logout Thunk
export const logoutThunk = createAsyncThunk("LogoutThunk", async (_, thunkApi) => {
    // try {
        // await axios.post(`${backendURL}/logout`, {}, { withCredentials: true });
        return null;
    // } catch (err) {
        // return thunkApi.rejectWithValue("Logout failed");
    // }
});


// Thunks...

export const PRC = createSlice({
  name: "PRCSlice",
  initialState: {
    isPending: false,
    currentUser: Cookies.get('currentUser') ? JSON.parse(Cookies.get('currentUser')) : null,  // 👈 read from cookie
    loginStatus: Cookies.get('currentUser') ? true : false,  // 👈 also loginStatus
    errorOccured: false,
    errorMessage: {},
  },
  reducers: {
    resetState1: (state, action) => {
      state.currentUser = null;
      state.isPending = false;
      state.loginStatus = false;
      state.errorMessage = "";
      state.errorOccured = false;
      Cookies.remove('currentUser');  // 👈 remove cookie on logout/reset
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PRCThunk.pending, (state) => {
        state.isPending = true;
      })
      .addCase(PRCThunk.fulfilled, (state, action) => {
        state.isPending = false;
        state.errorOccured = false;
        state.loginStatus = true;
        state.errorMessage = "";
        state.currentUser = action.payload;
        Cookies.set('currentUser', JSON.stringify(action.payload));  // 👈 save to cookie
      })
      .addCase(PRCThunk.rejected, (state, action) => {
        state.isPending = false;
        state.errorOccured = true;
        state.loginStatus = false;
        state.errorMessage = action.payload;
      })
      .addCase(PRCcheckAuthThunk.fulfilled, (state, action) => {
        state.loginStatus = true;
        state.currentUser = action.payload;
        Cookies.set('currentUser', JSON.stringify(action.payload));  // 👈 also update cookie
      })
      .addCase(PRCcheckAuthThunk.rejected, (state) => {
        state.loginStatus = false;
        state.currentUser = null;
        Cookies.remove('currentUser');  // 👈 remove if auth fails
      })
      .addCase(logoutThunk.fulfilled, (state) => {
        state.loginStatus = false;
        state.currentUser = null;
        Cookies.remove('currentUser');  // 👈 remove on logout
      });
  },
});

export const { resetState1 } = PRC.actions;

export default PRC.reducer;
